import React from 'react';
import { servicesData } from '../data/mock';
import { Card, CardContent } from './ui/card';
import { Camera, Image, Film, Building2 } from 'lucide-react';

const iconMap = {
  0: Film,
  1: Image,
  2: Camera,
  3: Building2
};

const Services = () => {
  return (
    <section className="bg-[#0d0d0d] py-20 md:py-32">
      <div className="max-w-[87.5rem] mx-auto px-5 md:px-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <p className="font-['DM_Sans'] text-[#e8ff47] text-sm uppercase tracking-widest mb-4">
            What We Do
          </p>
          <h2 className="font-['Bebas_Neue'] text-white text-5xl md:text-7xl tracking-wide">
            CONTENT BUILT FOR FITNESS
          </h2>
        </div>

        {/* Service Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {servicesData.map((service, index) => {
            const Icon = iconMap[index];
            return (
              <Card 
                key={service.id}
                className="bg-[#302f2c] border-[#3f4816] border-opacity-50 hover:bg-[#3f4816] transition-all duration-300 group"
              >
                <CardContent className="p-8 md:p-10">
                  <div className="mb-6">
                    <Icon className="w-12 h-12 text-[#e8ff47]" strokeWidth={1.5} />
                  </div>
                  <h3 className="font-['Bebas_Neue'] text-[#e8ff47] text-3xl md:text-4xl mb-4">
                    {service.title}
                  </h3>
                  <p className="font-['DM_Sans'] text-[#dfddd6] text-base md:text-lg leading-relaxed">
                    {service.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
